export const STOCK_MODULE_NAME = "stock";
